import { config } from "../config/config";
import { useMeritAuth0 } from "../hooks/auth";
import axios from "axios";

export function useFormApi() {
  const { accessToken } = useMeritAuth0();

  const submitForm = async (formData: FormData) => {
    await axios.post<FormData>(`${config.api.baseUrl}/api/user/claim`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  return {
    submitForm,
  };
}
